/**
 * Labstep
 *
 * @module screens/Overview/MessageBoard
 * @desc Overview of a workspace - Message board
 */

import { ThreadItemContainer } from 'labstep-web/components/Thread/Item';
import { ICONS } from 'labstep-web/constants/icons';
import { Card } from 'labstep-web/core/Card/Card';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { MessageBoardProps } from './types';

export const MessageBoard: React.FC<MessageBoardProps> = ({
  group,
}) => (
  <Card
    header={
      <>
        <Icon name={ICONS.thread.primary} /> Message Board
      </>
    }
    size="tiny"
  >
    <ThreadItemContainer
      thread={group.thread}
      noCommentsMessage={
        <CardEmptyState
          src="/img/empty-state/comments.svg"
          title="No comments"
          explanation="Start a discussion with workspace members."
        />
      }
    />
  </Card>
);
